// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"74416df7","94":"13f4be61","354":"fb6ee898","422":"8a31bfb4","530":"43f9034d","580":"da5fd097"}[chunkId] + ".css";
};